export default function SiteCard({ title, domain, url, description, status, iconSvg }) {
  const getStatusBadge = () => {
    const s = String(status ?? '').toLowerCase().trim();

    if (s === '1' || s === 'working' || s === 'active') {
      return (
        <span className="status-badge active">
          <span className="status-dot"></span>
          Working
        </span>
      );
    }

    if (s === '3' || s === 'broken') {
      return (
        <span className="status-badge broken">
          <span className="status-dot"></span>
          Broken
        </span>
      );
    }

    // Default or code 2: Unmaintained / Inactive
    return (
      <span className="status-badge unmaintained">
        <span className="status-dot"></span>
        Unmaintained
      </span>
    );
  };

  return (
    <div className="site-card fade-in">
      <div className="card-header">
        <div className="card-icon-title">
          {iconSvg && <span className="card-icon-wrapper">{iconSvg}</span>}
          <div>
            <h3 className="card-title">{title}</h3>
            <a 
              href={url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="card-domain"
            >
              {domain}
            </a>
          </div>
        </div>
        {getStatusBadge()}
      </div>
      <p className="card-description">{description || 'Description placeholder...'}</p>
    </div>
  );
}
